// client/src/components/feedback/FeedbackModal.js
import { useState } from 'react'
import ApiFeedback from '../../api/ApiFeedback'
import './FeedbackModal.css'

function FeedbackModal({ onClose, originPage }) {
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus('')
    setIsSubmitting(true)

    try {
      await ApiFeedback.create(message, originPage)
      setStatus('Thank you for your feedback!')
      setMessage('')

      // Close modal after a brief delay
      setTimeout(() => {
        onClose()
      }, 1500)
    } catch (err) {
      setStatus(err.message)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className="feedback-modal-backdrop" onClick={handleBackdropClick}>
      <div className="feedback-modal">
        <div className="feedback-modal-header">
          <h3>Send Feedback</h3>
          <button
            className="feedback-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="feedback-modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="feedback" className="form-label">
                Tell us what you think about this page or feature
              </label>
              <textarea
                id="feedback"
                className="form-control"
                rows="4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Your feedback helps us improve the platform..."
                required
                disabled={isSubmitting}
              />
            </div>

            {status && (
              <div
                className={`feedback-status ${
                  status.includes('Thank you') ? 'success' : 'error'
                }`}
              >
                {status}
              </div>
            )}

            <div className="feedback-modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting || !message.trim()}
              >
                {isSubmitting ? 'Sending...' : 'Send Feedback'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default FeedbackModal
